import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { Input } from 'reactstrap'
import './student-list.scss';
import { ImageConstants, AccessRights, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source';
import SchoolUserApi from '../../../apis/student'
import AddStudentComponent from '../add-student/add-student';
import StudentBulkUpload from '../student-bulk-import/student-bulk-import';
import CWConfirm from '../../common/cw-confirmation-modal/cw-confirmation-modal'
import SchoolApi from '../../../apis/school';
import { Modal, ModalBody } from "reactstrap";
import AddSection from '../add-section/add-section'
import SessionCache from '../../routes/session-cache';
import InviteStudents from '../invite-students-v2/invite-students-v2';
import MasterDataAPI from '../../../apis/master-data'
import Path from '../../routes/routes-path'
import Dropdown from '../../common/dropdown-v2/dropdown';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
const REJECT_REASONS = [
    { title: "NOT_SCHOOL_STUDENT", value: "Not School Student" },
    { title: "ALREADY_EXISTS", value: "Already Exists" }
]
class StudentList extends Component {
    state = {
        classDetails: this.props.classDetails,
        studentList: [],
        removedStudents: []
    }

    accessRights = SessionCache.getAllowedModule()

    componentDidMount() {
        this.getStudent()
    }

    getStudent(payload = {}) {
        payload.class = this.state.classDetails?.class
        payload.board = this.state.classDetails?.board

        if(!this.state.classDetails?.noSectionInClass) { 
            payload.sectionId = this.state.classDetails?._id
        }

        
        SchoolUserApi.getSchoolUsers(payload)
            .then(response => {
                this.setState({ studentList: response.response, meta: response.meta })
            }).catch(err => {
            })
    }

    getUsersUpgradedCount(payload = {}) {
        payload.class = this.state.classDetails?.class
        payload.board = this.state.classDetails?.board
        payload.sectionId = this.state.classDetails?._id
        SchoolUserApi.getUsersUpgradedCount(payload)
            .then(response => {
                this.setState({ alreadyUpgradedCount: response?.count || 0 })
            }).catch(err => {
            })
    }

    getSections() {
        let payload = {
            _id: this.props.classDetails?._id
        }
        SchoolApi.getSections(payload)
            .then(response => {
                let section = response?.response[0] || {}
                this.setState({ classDetails: section })
            }).catch(err => {
            })
    }


    getUpdateToSection(payload) {
        SchoolApi.getSections(payload)
            .then(response => {
                let section = response?.response[0] || null
                this.setState({ updateToSection: section })
            }).catch(err => {
            })
    }

    getClassDetails() {
        if (this.state.updateToClass) return

        let classDetail = this.props.classDetails
        let payload = { limit: 100 };

        MasterDataAPI.getClass(payload)
            .then((classData) => {
                let classes = classData.response
                let currentClassOrder = "", classHashByOrder = {}
                for (let i = 0; i < classes.length; i++) {
                    let item = classes[i]
                    if (item.title === classDetail.class) currentClassOrder = item.order
                    classHashByOrder[item.order] = item
                }

                let updateToClass = classHashByOrder[+currentClassOrder + 1]

                if (updateToClass) this.getUpdateToSection({
                    schoolId: classDetail.schoolId,
                    section: classDetail.section,
                    class: updateToClass.title,
                    board: classDetail.board
                })
                this.setState({ updateToClass, currentClassOrder })

            }).catch(err => {
            })
    }


    onClickBack = () => {
        this.props.goBack && this.props.goBack()
    }

    onClickAddStudent(item, mode) {
        this.setState({ openAddStudent: true, selectedUser: item, mode })
    }

    onClickInvite(item, type) {
        this.setState({ emailSendConfirmModal: true, deleteMessage: "Are you sure want send invitation", inviteUser: item, inviteType: type })
    }

    closeAddStudentModal = () => {
        this.setState({ openAddStudent: false, })
    }

    onSaveStudent = (numberOfstudentAdded = 0) => {
        this.getStudent()
        let classDetails = this.state.classDetails
        classDetails.numberOfStudents += numberOfstudentAdded
        this.setState({ openAddStudent: false, classDetails, showBulkImportModal: false })
    }


    showConfirmModal = (item) => {
        let deleteItem = []
        let bulkDelete = false
        if (item === "bulk") {
            deleteItem = this.state.removedStudents
            bulkDelete = true
        } else if (item) {
            deleteItem = [item._id]
        }

        this.setState({ showConfirmModal: true, deleteMessage: `Are you sure want to delete ${item ? item?.name : "selected students"} from School ?`, deleteItem, bulkDelete })
    }


    onClickSectionEdit = () => {
        this.setState({ showSectionEdit: true })
    }

    hideSectionEdit = (refetch) => {
        if (refetch) {
            this.getSections()
        }
        this.setState({ showSectionEdit: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showSectionDeleteModal = () => {
        this.setState({ showSectionDeleteModal: true, deleteMessage: "Are you sure want to delete this section" })
    }

    onClickBulkInvite(type) {
        this.setState({ bulkInviteConfirmModal: true, bulkInviteMessage: "Are you sure want send invitation to selected users", inviteType: type })
    }

    onClassSectionUpdate() {
        this.setState({ showClassSectionUpdate: true })
    }

    showAcceptBulkConfirmModal = (item) => {
        let message = `Are you sure, you want to approve selected students from this school?`
        this.setState({ selectedUser: item, showAcceptBulkConfirmModal: true, acceptMessage: message })
    }

    showRejectBulkConfirmModal = (item) => {
        let message = `Are you sure, you want to reject selected students from this school?`
        this.setState({ selectedUser: item, showRejectBulkConfirmModal: true, rejectMessage: message })
    }

    showAcceptConfirmModal = (item) => {
        let message = `Are you sure, you want to approve ${item.name} from this school?`
        this.setState({ selectedUser: item, showAcceptConfirmModal: true, acceptMessage: message })
    }

    showRejectConfirmModal = (item) => {
        let message = `Are you sure, you want to reject ${item.name} from this school?`
        this.setState({ selectedUser: item, showRejectConfirmModal: true, rejectMessage: message })
    }

    showStudentDetails = (item) => {
        this.setState({ selectedStudent: item, showStudentDetails: true })
    }

    hideConfirmModal = () => {
        this.setState({ emailSendConfirmModal: false, showConfirmModal: false, bulkInviteConfirmModal: false, showAcceptConfirmModal: false, showRejectConfirmModal: false, showStudentDetails: false, showAcceptBulkConfirmModal: false, showRejectBulkConfirmModal: false, showClassSectionUpdate: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showInviteStudents = () => {
        this.setState({ showInviteStudents: true })
    }

    hideInviteStudents = (success) => {
        if (success === true) this.showToaster('info', 'Message shared successfully on Whatsapp')
        this.setState({ showInviteStudents: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showToaster(type, message) {
        this.setState(
            {
                showToaster: true,
                toasterMessage: message,
                toasterType: type
            },
            () => {
                setTimeout(() => {
                    this.hideToaster()
                }, 3000)
            }
        )
    }

    hideToaster() {
        this.setState({
            showToaster: false
        })
    }

    removeUser = () => {
        let payload = {}
        if (this.state.bulkDelete) {
            payload.ignoreUserId = this.state.deleteItem
            payload.bulkDelete = true
        } else {
            payload.userId = this.state.deleteItem
        }
        SchoolUserApi.deleteSchoolUser(payload)
            .then(response => {
                if (this.state.bulkDelete) {
                    this.showToaster("info", `${this.state.meta?.count - this.state.deleteItem?.length} students deleted`)
                }
                let classDetails = this.state.classDetails
                classDetails.numberOfStudents = (classDetails.numberOfStudents - this.state.deleteItem.length)
                this.getStudent()
                this.setState(classDetails)
                this.hideConfirmModal()
                this.hideBulkActions()
            }).catch(err => {
                console.log(err)
            })
    }

    bulkStudentImport = () => {
        this.setState({ showBulkImportModal: true })
    }

    hideBulkStudentImport = () => {
        this.setState({ showBulkImportModal: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        this.getStudent()
        ReactTooltip.hide()
    }

    sendInvite = () => {
        let payload = {
            userId: this.state.inviteUser?._id,
            type: this.state.inviteType
        }
        SchoolApi.sendStudentInvite(payload)
            .then(response => {
                this.getStudent()
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    renderContact(contactDetails = []) {
        return (
            <>
                {
                    contactDetails.length ? contactDetails.map(item => (
                        <div>
                            <div className='phone-number-title text-left'>{item.type}</div>
                            {
                                item.mobileNumber ? <div>{item.countryCode} {item.mobileNumber}</div> : ""
                            }
                            {
                                item.email ? <div>{item.email}</div> : ""
                            }
                        </div>
                    )) : ""
                }
            </>
        )

    }

    onClickAllCheckBox = () => {
        this.setState({ allStudentSelected: !this.state.allStudentSelected }, _ => {
            if (!this.state.allStudentSelected) {
                this.hideBulkActions()
            }
        })
    }

    removeSection = () => {
        let payload = { _id: this.state.classDetails._id }
        SchoolApi.deleteSchoolSection(payload)
            .then(response => {
                this.props.goBack && this.props.goBack(true)
            }).catch(err => {
                console.log(err)
            })
    }

    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = Constants.STUDENT_EXCEL_FORMAT_1
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    onChangePreviousyearMarkHandler = (value) => {
        this.setState({ previousYearMark: value })
    }

    onSaveEditMark = (index) => {
        let studentList = this.state.studentList || []
        let student = studentList[index]
        student.previousYearMark = { mark: this.state.previousYearMark }
        studentList[index] = student
        this.setState({ studentList, showPreviosMarkIndex: "", previousYearMark: "" })


        let payload = {
            _id: student?._id,
            previousYearMark: +this.state.previousYearMark
        }

        SchoolUserApi.updateSchoolUser(payload).then(response => {
        }).catch(err => {
        })
    }

    onEditPreviousYearMark = (index) => {
        this.setState({ showPreviosMarkIndex: index })
    }
    onClosePreviousYearMark = () => {
        this.setState({ showPreviosMarkIndex: "" })
    }

    getTeacherName(teachers) {

        let name = teachers.map(item => item?.firstName)
        return name.join(", ")
    }

    renderSectionEdit() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideSectionEdit} size={'lg'}>

                <ModalBody >

                    <div className="row">
                        <div className="col">
                            <img className="close-icon cursor-pointer" onClick={this.hideSectionEdit} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="header-text text-center">
                        <span>EDIT SECTION</span>
                    </div>

                    <AddSection mode="EDIT" sectionDetails={this.state.classDetails} onSave={this.hideSectionEdit} />

                </ModalBody>
            </Modal>
        )
    }


    changePreviousYearMark = (mark, index) => {
        return (
            <div className="cw-card d-inline-block previous-year-mark">
                <div className="close-icon-wrapper">
                    <img className="mark-close-icon cursor-pointer" onClick={this.onClosePreviousYearMark} src={getImageSource(ImageConstants.CROSS)} />
                </div>
                <div className='mt-2'>
                    <input className={`cw-input`} placeholder='Enter Marks'
                        value={this.state.mark}
                        onChange={(e) => this.onChangePreviousyearMarkHandler(e.target.value, index)} />
                </div>

                <div className='text-center mt-2'>
                    <button className="cw-button-primary text-center" onClick={() => this.onSaveEditMark(index)}>
                        Save
                    </button>
                </div>
            </div>
        )
    }

    renderAddStudent() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.closeAddStudentModal} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.closeAddStudentModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>{this.state.mode == "CREATE" ? "ADD A STUDENT" : "EDIT STUDENT"}</span>
                    </div>
                    <div className="px-4">
                        <AddStudentComponent mode={this.state.mode} selectedClass={this.state.classDetails} selectedUser={this.state.selectedUser} size={'lg'} onSave={this.onSaveStudent} onClose={this.closeAddStudentModal} />
                    </div>
                </ModalBody>
            </Modal>)
    }


    renderStudentList = () => {
        const { showBulkActions, selectedBulkAction, allStudentSelected, removedStudents, studentList } = this.state
        return (
            <div>
                <div className='row mt-5'>
                    <div className='col-3'>
                        <span className='screen-title'>STUDENT DATA</span>
                    </div>
                    <div className='col-9 text-right'>
                        <div className='row' onMouseEnter={ReactTooltip.rebuild}>
                            <div className='col' >
                                <span>
                                    {
                                        this.accessRights[AccessRights.INVITE_STUDENT] ?
                                            <span>
                                                <button className='cw-btn-md-v1 d-inline-block cw-btn-secondary mr-2' onClick={() => this.showInviteStudents()} data-tip="Invite Students">
                                                    INVITE STUDENTS VIA WHATSAPP
                                                </button>
                                            </span> : ""
                                    }
                                    {
                                        this.accessRights[AccessRights.ADD_STUDENT] ?
                                            <span>
                                                <button className='cw-btn-md d-inline-block cw-btn-primary mr-2' onClick={() => this.onClickAddStudent({}, 'CREATE')} data-tip="Add New Students">
                                                    ADD NEW STUDENT
                                                </button>
                                            </span> : ""
                                    }
                                    {
                                        this.accessRights[AccessRights.BULK_UPLOAD_STUDENT] ?
                                            <span>
                                                <button className='cw-btn-md cw-btn-success ' onClick={() => this.bulkStudentImport()} data-tip="Bulk Import Students">
                                                    BULK EXCEL UPLOAD
                                                </button>
                                                <div>
                                                    <span className='check-text' onClick={this.showExcelFormat}>
                                                        <img
                                                            className='export-xls'
                                                            src={getImageSource(ImageConstants.XLS_BLUE)}
                                                        />
                                                        Check Format Here
                                                    </span>
                                                </div>
                                            </span>
                                            : ""
                                    }
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='students-count'>
                    {selectedBulkAction &&
                        <span>{this.state.meta?.count - removedStudents.length} students selected{selectedBulkAction == "classsection" && this.state.alreadyUpgradedCount ? `, ${this.state.alreadyUpgradedCount} of them already upgraded` : ""}</span>
                    }
                </div>
                <div id="table-scoll" className="table-responsive mt-4">
                    <table className="table cw-table">
                        <thead>
                            <tr>
                                <th className='th-left-radius'>
                                    {selectedBulkAction &&
                                        <div className={`${allStudentSelected && removedStudents.length <= 0 ? "active-checkbox" : "inactive-checkbox"} d-inline-block`} onClick={this.onClickAllCheckBox}>
                                            <img className="d-inline-block img" src={getImageSource(allStudentSelected && removedStudents.length <= 0 ? ImageConstants.RECT_TICK : ImageConstants.RECT)} />
                                        </div>
                                    }
                                </th>
                                <th>Name</th>
                                <th>Roll no</th>
                                <th>Contact</th>
                                <th>Status</th>
                                <th className="text-center">Previous Year Marks</th>
                                <th className='th-right-radius list-actions-header' onMouseEnter={ReactTooltip.rebuild}>
                                    <div className='text-right'>
                                        <button className={`bulk-action-btn`} onClick={_ => this.showBulkActions()}>
                                            Bulk Actions
                                        </button>
                                    </div>
                                    {showBulkActions &&
                                        <div className='bulk-actions'>
                                            <div className='text-right pr-2' onClick={this.hideBulkActions}>
                                                <img alt="" className="vector-icon cursor-pointer" src={getImageSource(ImageConstants.CROSS)} />
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "email" ? "active-action" : selectedBulkAction && selectedBulkAction !== "email" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "email" ? this.onClickBulkInvite("email") : this.onSelectBulkAction("email") }}>
                                                <img alt="" className="vector-icon" src={getImageSource(selectedBulkAction !== "email" ? ImageConstants.ENVELOPE : ImageConstants.ENVELOPE_WHITE)} /> <span className='action-name'>Send Email Reminder</span>
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "whatsapp" ? "active-action" : selectedBulkAction && selectedBulkAction !== "whatsapp" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "whatsapp" ? this.onClickBulkInvite("whatsapp") : this.onSelectBulkAction("whatsapp") }}>
                                                <img alt="" className="vector-icon" src={getImageSource(selectedBulkAction !== "whatsapp" ? ImageConstants.WHATSAPP : ImageConstants.WHATSAPP_WHITE)} /> <span className='action-name'>Send Whatsapp Reminder</span>
                                            </div>
                                            {/* <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "sms" ? "active-action" : selectedBulkAction && selectedBulkAction !== "sms" ? "hide" : ""} ${!studentList.length ? "disabled": ""}`} onClick={() => { if(studentList.length > 0) selectedBulkAction === "sms" ? this.onClickBulkInvite("sms") : this.onSelectBulkAction("sms") }}>
                                                <img alt="" className="vector-icon" src={getImageSource(selectedBulkAction !== "sms" ? ImageConstants.MESSAGE : ImageConstants.MESSAGE_WHITE)} /> <span className='action-name'>Send SMS Reminder</span>
                                            </div> */}
                                            {!selectedBulkAction &&
                                                <div className='divider'></div>
                                            }
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "classsection" ? "active-action" : selectedBulkAction && selectedBulkAction !== "classsection" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "classsection" ? this.onClassSectionUpdate() : this.onSelectBulkAction("classsection") }}>
                                                <img alt="" className="vector-icon" src={getImageSource(selectedBulkAction !== "sms" ? ImageConstants.CLASS_SECTION_ICON : ImageConstants.CLASS_SECTION_ICON_WHITE)} /> <span className='action-name'>Upgrade Class</span>
                                            </div>
                                            {!selectedBulkAction &&
                                                <div className='divider'></div>
                                            }
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "approve" ? "active-action" : selectedBulkAction && selectedBulkAction !== "approve" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "approve" ? this.showAcceptBulkConfirmModal() : this.onSelectBulkAction("approve") }}>
                                                <img alt="" className="vector-icon" src={getImageSource(selectedBulkAction !== "approve" ? ImageConstants.TICK_BLACK : ImageConstants.TICK_BLACK)} /> <span className='action-name'>Approve Students</span>
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "reject" ? "active-action" : selectedBulkAction && selectedBulkAction !== "reject" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "reject" ? this.showRejectBulkConfirmModal() : this.onSelectBulkAction("reject") }}>
                                                <img alt="" className="vector-icon" src={getImageSource(selectedBulkAction !== "reject" ? ImageConstants.CROSS_BLACK : ImageConstants.CROSS_BLACK)} /> <span className='action-name'>Reject Students</span>
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer delete-icon ${selectedBulkAction === "delete" ? "active-action" : selectedBulkAction && selectedBulkAction !== "delete" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "delete" ? this.showConfirmModal("bulk") : this.onSelectBulkAction("delete") }}>
                                                <img alt="" className="vector-icon" src={getImageSource(selectedBulkAction !== "delete" ? ImageConstants.DELETE_RED : ImageConstants.DELETE_WHITE)} /> <span className='action-name'>Delete</span>
                                            </div>
                                        </div>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {
                                this.state.studentList && this.state.studentList.length ? this.state.studentList.map((item, index) => (

                                    <tr className="mt-4" onMouseEnter={ReactTooltip.rebuild}>
                                        <td>
                                            {selectedBulkAction && <>
                                                {
                                                    selectedBulkAction == "classsection" && item.rcentlyUpgraded ?
                                                        <img alt="" className="d-inline-block img" src={getImageSource(ImageConstants.RECT_INACTIVE)} />
                                                        :
                                                        removedStudents.findIndex(rs => rs === item._id) < 0 ?
                                                            <div className='text-left active-checkbox d-inline-block' onClick={_ => this.onToggleSelectedStudent(item._id)}>
                                                                <img alt="" className="d-inline-block img" src={getImageSource(ImageConstants.RECT_TICK)} />
                                                            </div>
                                                            : <div className='text-left inactive-checkbox d-inline-block' onClick={_ => this.onToggleSelectedStudent(item._id)}>
                                                                <img alt="" className="d-inline-block img" src={getImageSource(ImageConstants.RECT)} />
                                                            </div>
                                                }
                                            </>
                                            }
                                        </td>
                                        <td className="">
                                            <div className="name-text cursor-pointer" onClick={() => { this.onClickAddStudent(item, "EDIT") }}>{item.name}</div>
                                            {selectedBulkAction && item.rcentlyUpgraded ? <div className="py-2"><span className="recent-upgrad">{item.rcentlyUpgraded}</span></div> : ""}
                                            {item.schoolApprovalStatus?.type !== "TO_BE_APPROVED" &&
                                                <>
                                                    <div><small>School Connect Code : </small> </div>
                                                    <div className="pl-4">{item.verificationCode} </div>
                                                </>
                                            }
                                            {
                                                this.accessRights[AccessRights.ADD_STUDENT] && item.schoolApprovalStatus?.type === "TO_BE_APPROVED" &&
                                                <div>
                                                    <span onClick={_ => this.showAcceptConfirmModal(item)} className='cursor-pointer'>
                                                        <img
                                                            alt=""
                                                            data-tip={"Accept Student profile"}
                                                            className='approve-icn'
                                                            src={getImageSource(ImageConstants.GREEN_TICK_V1)}
                                                        />
                                                    </span>
                                                    <span onClick={_ => this.showRejectConfirmModal(item)} className='cursor-pointer'>
                                                        <img
                                                            alt=""
                                                            data-tip={"Reject Student profile"}
                                                            className='approve-icn'
                                                            src={getImageSource(ImageConstants.RED_REMOVE)}
                                                        />
                                                    </span>
                                                </div>
                                            }
                                        </td>
                                        <td>{item.rollNumber}</td>
                                        <td className=''>{this.renderContact(item?.contactDetails)}</td>
                                        <td>{<span className={`${item.status?.type == 'ONBOARDED' ? "onboard-text" : "invite-sent-text"}`}>{item.schoolApprovalStatus?.type === "TO_BE_APPROVED" ? "To be approved" : item?.status?.typeText}</span>}</td>
                                        <td className="text-center">{
                                            item.previousYearMark?.mark ? item.previousYearMark?.mark :
                                                <div className="mark-td">
                                                    <span className="add-previous-mark" onClick={() => { this.onEditPreviousYearMark(index) }}> ADD</span>
                                                    <br />
                                                    {this.state.showPreviosMarkIndex === index ? this.changePreviousYearMark(0, index) : ""}
                                                </div>
                                        }
                                        </td>

                                        <td className='list-actions'>
                                            <div className='pr-2'>
                                                {
                                                    item.status && item.status?.type == 'INVITE_SENT' && this.accessRights[AccessRights.INVITE_STUDENT] ? <span>
                                                        <img className="email-icn mt-2 cursor-pointer" onClick={() => this.onClickInvite(item, "email")} src={getImageSource(ImageConstants.ENVELOPE)} data-tip="Invite Student Via Email" />
                                                    </span> : ""
                                                }
                                                {
                                                    item.status && item.status?.type == 'INVITE_SENT' && this.accessRights[AccessRights.INVITE_STUDENT] ? <span>
                                                        <img className="email-icn mt-2 cursor-pointer" onClick={() => this.onClickInvite(item, "whatsapp")} src={getImageSource(ImageConstants.WHATSAPP)} data-tip="Invite Student Via Whatsapp" />
                                                    </span> : ""
                                                }
                                                {/* {
                                                    item.status && item.status?.type == 'INVITE_SENT' && this.accessRights[AccessRights.INVITE_STUDENT] ? <span>
                                                        <img className="email-icn mt-2 cursor-pointer" onClick={() => this.onClickInvite(item, "sms")} src={getImageSource(ImageConstants.MESSAGE)} data-tip="Invite Student Via SMS" />
                                                    </span> : ""
                                                } */}
                                            </div>
                                            <div className='pr-2'>
                                                {
                                                    this.accessRights[AccessRights.EDIT_STUDENT] ?
                                                        <span onClick={() => { this.onClickAddStudent(item, "EDIT") }}>
                                                            <img className="vector-icon mt-2 cursor-pointer" src={getImageSource(ImageConstants.EDIT)} data-tip="Edit Student" />
                                                        </span> : ""
                                                }
                                                {
                                                    this.accessRights[AccessRights.DELETE_STUDENT] ?
                                                        <span onClick={() => { this.showConfirmModal(item) }} >
                                                            <img className="vector-icon mt-2 cursor-pointer" src={getImageSource(ImageConstants.DELETE_RED)} data-tip="Delete Student" />
                                                        </span> : ""
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))
                                    : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                            }
                        </tbody>
                    </table>
                </div >
            </div>
        )
    }

    renderRejectPopup() {
        const { rejectReason, rejectDetails, isValidForm, isSubmit, showError } = this.state
        return (
            <Modal className="cw-custom-modal reject-modal" isOpen={true} toggle={this.hideConfirmModal} size={"lg"}>
                <ModalBody >
                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideConfirmModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="reject-modal-body">
                        <div className="title">Reject Reason </div>
                        <div className='row'>
                            <div className='col'>
                                <Dropdown
                                    text='value'
                                    placeholder='Select Reject Reason'
                                    options={REJECT_REASONS}
                                    invalid={showError && !rejectReason}
                                    onSelect={option =>
                                        this.onSelect(option, 'rejectReason')
                                    }
                                    value={rejectReason}
                                    style={{ background: '#F6F7F5' }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <textarea className={`message-input ${showError && !rejectDetails ? 'invalid' : ''}`} placeholder='Enter any other details'
                                    value={rejectDetails}
                                    onChange={(e) => this.onChangeHandler(e, 'rejectDetails')} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col text-center mt-4'>
                                {this.state.errorMessage ? <div className="text-danger"><strong>{this.state.errorMessage} </strong></div> : ""}
                                <button className={`cw-button-primary ${(!isValidForm || isSubmit) ? "disable-button" : ""}`} onClick={_ => this.onRejectSubmit()}>
                                    REJECT
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    onSelect = (option, key) => {
        this.setState({ [key]: option }, _ => {
            this.validatePayload()
        })
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value }, _ => {
            this.validatePayload()
        })
    }

    validatePayload = _ => {
        this.setState({
            isValidForm: false
        })
        if (!this.state.rejectReason) return false
        if (!this.state.rejectDetails) return false
        this.setState({
            isValidForm: true
        })
        return true
    }

    showBulkActions = _ => {
        this.setState({
            showBulkActions: true
        })
    }

    hideBulkActions = _ => {
        const payload = {}
        this.getStudent(payload)
        this.setState({
            showBulkActions: false,
            selectedBulkAction: null,
            selectedStudents: [],
            allStudentSelected: false,
            removedStudents: []
        })
    }

    sendBulkInvite = () => {
        let payload = {
            students: this.state.removedStudents,
            type: this.state.inviteType
        }
        SchoolUserApi.sendStudentBulkInvite(payload)
            .then(response => {
                this.showToaster("info", `Message sent to ${this.state.meta?.count - this.state.removedStudents?.length} students`)
                this.hideConfirmModal()
                this.getStudent({})
                this.setState({
                    selectedBulkAction: ""
                })
            }).catch(err => {
                console.log(err)
            })
    }

    assignClassSection = type => {

        if (type === "NO" && !this.state.updateToSection) {
            this.hideConfirmModal()
            return
        }

        let payload = {
            board: this.state.classDetails?.board,
            currentClass: this.state.classDetails?.class,
            updateToClass: this.state.classDetails?.class === 'Class 9' ? "Class 10" : this.state.updateToClass?.title,
            removedStudents: this.state.removedStudents,
            currentSection: this.state.classDetails?.section,
            currentSectionId: this.state.classDetails?._id,
        }

        console.log(this.state.updateToSection)

        if (type != "NO") {
            payload = {
                ...payload,
                updateSectionId: this.state.updateToSection?._id,
                updateToSection: this.state.updateToSection?.section,
            }
        }
        SchoolUserApi.bulkAssignClassSection(payload).then(res => {
            this.setState({ isSubmit: false })
            this.getStudent({})
            this.hideConfirmModal()
            if ((this.state.classDetails?.class !== 'Class 9') && (!this.state.updateToSection || type === "NO")) {
                let url = `${Path.STUDENTS}?b=${this.state.classDetails?.class}&c=${this.state.updateToClass?.title}&unassign=true`
                this.props.history.push(url)
            }
        }).catch(e => {
            this.setState({ isSubmit: false })
        })
    }

    onRejectSubmit = _ => {
        const { selectedBulkAction } = this.state
        this.setState({ showError: true })
        let isValid = this.validatePayload()
        if (!isValid) {
            this.setState({
                errorMessage: "Reject Reason and Message are required fields"
            })
            return
        }
        this.setState({ isSubmit: true })
        if (selectedBulkAction === "approve" || selectedBulkAction === "reject") {
            this.userSchoolApprovalBulkUpdate(false)
        } else {
            this.userSchoolApprovalStatusUpdate(false)
        }
    }

    userSchoolApprovalStatusUpdate = approved => {
        const payload = {
            schoolUserId: this.state.selectedUser._id,
            userId: this.state.selectedUser.userId,
            schoolApprovalStatus: {
                type: approved ? "APPROVED" : "REJECTED",
                typeText: approved ? "Approved" : "Rejetced"
            }
        }
        if (!approved) {
            payload.rejectDetails = this.state.rejectDetails
            payload.rejectReason = this.state.rejectReason
        }
        SchoolUserApi.userSchoolApprovalStatusUpdate(payload).then(res => {
            this.setState({ isSubmit: false })
            this.getStudent({})
            this.hideConfirmModal()
        }).catch(e => {
            this.setState({ isSubmit: false })
        })
    }

    userSchoolApprovalBulkUpdate = approved => {
        const { removedStudents } = this.state;
        const payload = {
            students: removedStudents,
            schoolApprovalStatus: {
                type: approved ? "APPROVED" : "REJECTED",
                typeText: approved ? "Approved" : "Rejetced"
            }
        }
        if (!approved) {
            payload.rejectDetails = this.state.rejectDetails
            payload.rejectReason = this.state.rejectReason
        }
        SchoolUserApi.userSchoolApprovalBulkUpdate(payload).then(res => {
            this.showToaster("info", `${this.state.meta?.count - removedStudents?.length} students ${approved ? "approved" : "rejected"}`)
            this.setState({ isSubmit: false })
            this.getStudent({})
            this.hideConfirmModal()
            this.hideBulkActions()
        }).catch(e => {
            this.setState({ isSubmit: false })
        })
    }

    onSelectBulkAction(action) {
        const payload = {}
        if (action === "email" || action === "whatsapp" || action === "sms") payload.status = "INVITE_SENT"
        if (action === "approve" || action === "reject") payload.schoolApprovalStatus = "TO_BE_APPROVED"
        if (action === "delete") {
            payload.forBulkDelete = true
        }
        this.getStudent(payload)
        if (action === "classsection") {
            this.getClassDetails()
            this.getUsersUpgradedCount()
        }

        this.setState({
            selectedBulkAction: action,
            allStudentSelected: true
        })
    }

    onToggleSelectedStudent = id => {
        const { removedStudents } = this.state
        const idx = removedStudents.findIndex(ss => ss === id)
        if (idx > -1) {
            removedStudents.splice(idx, 1)
        } else {
            removedStudents.push(id)
        }
        this.setState({
            removedStudents
        })
    }

    renderClassSectionModal() {
        const { selectedClass, section, sectionId, isSubmit } = this.state
        console.log(this.state.classDetails?.class)
        return (
            <Modal className="cw-custom-modal class-section reject-modal" isOpen={true} toggle={this.hideConfirmModal} size={"md"}>
                <ModalBody >
                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideConfirmModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className='title'>Do you want to move all the students to {this.state.updateToClass?.title || this.state.classDetails?.class === 'Class 9' ? "Class 10" : ''} {this.state.updateToSection?.section || ""}</div>

                    <div className='row py-2'>
                        <div className='col text-center mt-4'>
                            <button className={`cw-btn-md cw-btn-success mr-2`} onClick={_ => this.assignClassSection("NO")}>
                                NO
                            </button>
                            <button className={`cw-btn-md d-inline-block cw-btn-primary`} onClick={_ => this.assignClassSection()}>
                                YES
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    render() {
        return (
            <div className='student-list'>

                <div>
                    <img src={getImageSource(ImageConstants.BACK_ICON)} className='back-icon cursor-pointer' onClick={this.onClickBack} />
                </div>

                <div className='mt-5'><span className='class-name'>{this.state.classDetails?.class}</span></div>

                <div className='class-details-card mt-3'>
                    <div className='row'>
                        <div className='col class-details-wrapper'>
                            <div className='class-details-title'>SECTION</div>
                            <div className='class-details-value'>{this.state.classDetails?.section}</div>
                        </div>
                        <div className='col class-details-wrapper'>
                            <div className='class-details-title'>BOARD</div>
                            <div className='class-details-value'>{this.state.classDetails.board}</div>
                        </div>
                        <div className='col class-details-wrapper'>
                            <div className='class-details-title'>MATH TEACHER</div>
                            <div className='class-details-value'>{this.getTeacherName(this.state.classDetails.teacher)}</div>
                        </div>
                        <div className='col class-details-wrapper'>
                            <div className='class-details-title'>STUDENTS</div>
                            <div className='class-details-value'>{this.state.studentList.length || 0}</div>
                        </div>
                        {/* <div className='col class-details-wrapper border-right-none'>
                            <div className='class-details-title'>MATH HOD</div>
                            <div className='class-details-value'>{this.state.classDetails.hod?.firstName}</div>
                        </div> */}
                        {/* <div className='col pt-2 text-center'>
                            <span className="p-2">
                                <img className="vector-icon pt-2 cursor-pointer" onClick={this.onClickSectionEdit} src={getImageSource(ImageConstants.EDIT)} />
                            </span>{
                                !this.state.classDetails.numberOfStudents ?
                                    <span className="p-2">
                                        <img className="vector-icon pt-2 cursor-pointer" onClick={this.showSectionDeleteModal} src={getImageSource(ImageConstants.DELETE)} />
                                    </span> : ""}
                        </div> */}
                    </div>
                </div>
                {this.renderStudentList()}

                {/* {this.state.studentList && this.state.studentList.length ? this.renderStudentList() :

                    <div className='no-record-container'>
                        <div className='text-center'><img className='no-record-image' src={getImageSource(ImageConstants.NO_RECORDS)} /></div>
                        <div className='text-center pt-2'><text >No data currently!!</text></div>
                    </div>} */}

                {this.state.openAddStudent && this.renderAddStudent()}
                {this.state.showBulkImportModal && <StudentBulkUpload mode={this.state.mode} selectedClass={this.state.classDetails} size={'lg'} onSave={this.hideBulkStudentImport} onClose={this.hideBulkStudentImport} />}
                {this.state.showConfirmModal && <CWConfirm modal={this.state.showConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.removeUser.bind(this)} />}
                {this.state.showSectionDeleteModal && <CWConfirm modal={this.state.showSectionDeleteModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.removeSection.bind(this)} />}
                {this.state.emailSendConfirmModal && <CWConfirm modal={this.state.emailSendConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.sendInvite.bind(this)} />}
                {this.state.showSectionEdit ? this.renderSectionEdit() : ""}
                {this.state.showInviteStudents && <InviteStudents onClose={this.hideInviteStudents} />}
                {this.state.bulkInviteConfirmModal && <CWConfirm modal={this.state.bulkInviteConfirmModal} close={this.hideConfirmModal} message={this.state.bulkInviteMessage} onOk={this.sendBulkInvite.bind(this)} />}
                {this.state.showAcceptConfirmModal && <CWConfirm modal={this.state.showAcceptConfirmModal} close={this.hideConfirmModal} message={this.state.acceptMessage} onOk={_ => this.userSchoolApprovalStatusUpdate(true)} />}
                {this.state.showAcceptBulkConfirmModal && <CWConfirm modal={this.state.showAcceptBulkConfirmModal} close={this.hideConfirmModal} message={this.state.acceptMessage} onOk={_ => this.userSchoolApprovalBulkUpdate(true)} />}
                {(this.state.showRejectConfirmModal || this.state.showRejectBulkConfirmModal) && this.renderRejectPopup()}
                {this.state.showStudentDetails && this.renderStudentDetails()}
                {this.state.showClassSectionUpdate && this.renderClassSectionModal()}
                {this.state.showToaster ? (
                    <div className='custom-toaster-modal'>
                        <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" />
                    </div>
                ) : (
                    ''
                )}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div >);
    }
}

export default StudentList;